// export const SERVER_BASE_URL = "https://sandhyapublications.in";
// export const SERVER_BASE_URL = "http://localhost:8000";
// export const SERVER_BASE_URL = "https://89f9-117-201-25-89.ngrok.io";
export const CLOUDINARY_CLOUD = "sandhya-publications";
export const SERVER_BASE_URL = "https://api.sandhyapublications.com";
// export const SERVER_BASE_URL = "https://6066-117-200-156-216.ngrok.io";
